<template>
  <el-autocomplete
    ref="autocomplete"
    class="c-autocomplete"
    v-model="query"
    :popper-append-to-body="popperAppendToBody"
    :fetch-suggestions="querySearch"
    :placeholder="autoPlaceholder"
    :disabled="disabled"
    :style="styleWidth"
    :size="size"
    @select="handleSelect"
    @blur="clearInput(true)"
    @focus="changeInput"
  >
    <i v-if="clear && clearable" @click="clearInput(false)" class="el-icon-close el-input__icon" slot="suffix" style="color: #666"></i>
    <i v-else @click="focusInput" class="el-icon-arrow-down el-input__icon" slot="suffix" style="color: #666"></i>
    <template slot-scope="{ item }">
      <div class="c-autocomplete-item" :style="stylItem">{{ item.name }}</div>
    </template>
  </el-autocomplete>
</template>
<script>
import { trim } from '@/common/js/utils'
export default {
  name: 'complete',
  props: {
    value: {
      type: [String, Number]
    },
    data: {
      type: Array
    },
    width: {
      type: [String, Number],
      default: 180
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    placeholder: {
      type: String
    },
    size: {
      type: String
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    styleWidth() {
      const width = parseInt(this.width)
      return { width: `${width}px` }
    },
    stylItem() {
      return this.size === 'mini' ? { fontSize: 'smaller' } : {}
    },
    clear() {
      return Boolean(trim(this.query))
    },
    autoPlaceholder() {
      return this.focusPlaceholder || this.placeholder
    }
  },
  methods: {
    querySearch(queryString, cb) {
      const query = this.focusPlaceholder && this.focusPlaceholder === queryString ? '' : queryString
      const d = this.data.filter((ret) => {
        return ret.name && ret.name.toLowerCase().indexOf(query.toLowerCase()) > -1
      })
      const result = query ? d : this.data
      cb(result)
    },
    handleSelect(item) {
      this.query = item.name
      this.$emit('on-select', item)
    },
    clearInput(cale) {
      if (this.disabled) return
      let param = { id: '', name: '' }
      const query = this.focusPlaceholder
      if (cale && query) {
        const patter = this.data.filter((ret) => ret.name === query)
        if (patter && patter.length) {
          param = patter.pop()
        }
      } else {
        this.focusPlaceholder = ''
        this.$emit('on-select', param)
      }
      this.query = param.name
    },
    changeInput() {
      const placeholder = JSON.parse(JSON.stringify(this.query))
      this.query = ''
      this.focusPlaceholder = placeholder
    },
    focusInput() {
      if (this.$refs && this.$refs.autocomplete) this.$refs.autocomplete.focus()
    },
    doLayout(val) {
      if (this.$refs && this.$refs.autocomplete) this.$refs.autocomplete.handleChange(val === null ? val : '')
    },
    bind(id) {
      if (id) {
        const item = this.data.filter((ret) => ret.id === id)
        item.length && (this.query = item.pop().name)
      } else if (id === '') {
        this.query = id
        this.focusPlaceholder = this.placeholder
      }
    }
  },
  data() {
    return {
      query: '',
      focusPlaceholder: ''
    }
  },
  watch: {
    value(nVal, oVal) {
      if (nVal || oVal) this.bind(nVal)
    }
  },
  created() {
    this.bind(this.value)
  }
}
</script>
